import AuthLayout from './AuthLayout'
import WideLayout from './WideLayout'
import MainLayout from './MainLayout'
import CustomLayout from './Custom'

export { AuthLayout }
export { WideLayout }
export { MainLayout }
export { CustomLayout }
export { WideLayoutProvider, useWideLayoutContext } from './WideLayout/context'

export default {
  main: MainLayout,
  wide: WideLayout,
  custom: CustomLayout,
  auth: AuthLayout,
}
